import { Card, CardContent } from '@/components/ui/card.js';
import { GuidelineSection } from './guideline-text.js';
import { cn } from '@/lib/tailwind-utils.js';

export const GuidelineTable = (props: GuidelineSection) => {
  const { type, paymentDescription, extraDescription, hasSpaceBetween } = props;
  const sectionTestId = `payments-guideline-section-${type.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <Card className={cn('w-full rounded-none', { 'mb-6': hasSpaceBetween })} data-testid={sectionTestId}>
      <CardContent className="p-0">
        <div className="grid grid-cols-[1fr_3fr_3fr] border-collapse">
          <div className="border-r border-gray-300 p-2 align-top">
            <p data-testid={`${sectionTestId}-type`}>{type}</p>
          </div>
          <div className="p-2 align-top border-gray-300 border-r" data-testid={`${sectionTestId}-payment`}>
            {paymentDescription}
          </div>
          <div className="p-2 align-top" data-testid={`${sectionTestId}-extra`}>
            {extraDescription}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
